import { render, staticRenderFns } from "./bigPackageManageDetailByLs.vue?vue&type=template&id=0e371ca5&scoped=true&"
import script from "./bigPackageManageDetailByLs.vue?vue&type=script&lang=js&"
export * from "./bigPackageManageDetailByLs.vue?vue&type=script&lang=js&"
import style0 from "./bigPackageManageDetailByLs.vue?vue&type=style&index=0&id=0e371ca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e371ca5",
  null
  
)

export default component.exports